export default "__VITE_PUBLIC_ASSET__1dd02281__"